import { createReducer } from '@reduxjs/toolkit'
import { preloadedState } from 'store/appState'
import { setClient, setClientReducer } from './setClientReducer'
import { setClients, setClientsReducer } from './setClientsReducer'
import {
  setCurrentClientId,
  setCurrentClientIdReducer,
} from './setCurrentClientIdReducer'
import {
  setCurrentShopId,
  setCurrentShopIdReducer,
} from './setCurrentShopIdReducer'
import { setClientShops, setClientShopsReducer } from './setClientShopsReducer'
import {
  setCreditLimitAvailable,
  setCreditLimitAvailableReducer,
} from './setCreditLimitAvailableReducer'
import {
  setClientLanguage,
  setClientLanguageReducer,
} from './setClientLanguageReducer'

const clientReducers = createReducer(preloadedState.client, builder => {
  builder.addCase(setClients.type, setClientsReducer)
  builder.addCase(setClient.type, setClientReducer)
  builder.addCase(setCurrentClientId.type, setCurrentClientIdReducer)
  builder.addCase(setCurrentShopId.type, setCurrentShopIdReducer)
  builder.addCase(setClientShops.type, setClientShopsReducer)
  builder.addCase(setCreditLimitAvailable.type, setCreditLimitAvailableReducer)
  builder.addCase(setClientLanguage.type, setClientLanguageReducer)
})

export default clientReducers
